export const createArticle = async (title, content, titleBel, contentBel, type, token) => {
  try {
    const currentDate = new Date().toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    const updatedContent = `<p>Опубликовано: ${currentDate}</p><hr class="editor-divider" />${content}`;
    const updateContentBel = `<p>Апублікавана: ${currentDate}</p><hr class="editor-divider" />${contentBel}`;

    const response = await fetch('/api/articles', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({
        title,
        content: updatedContent,
        titleBel,
        contentBel: updateContentBel,
        type,
      }),
    });

    if (!response.ok) {
      throw new Error('Ошибка при публикации статьи');
    }

    return await response.json();
  } catch (error) {
    console.error('Ошибка публикации статьи:', error);
    throw error;
  }
};

export const getArticlesByUserId = async (token, page = 1) => {
  const response = await fetch(`/api/articles/user?page=${page}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Ошибка при получении статей');
  }

  const data = await response.json();
  return data;
};

export const getFilteredArticlesByUserId = async (token, page = 1, typeNum = 0) => {
  const response = await fetch(`/api/articles/user/filter?page=${page}&type=${typeNum}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Ошибка при получении статей');
  }

  const data = await response.json();
  return data;
};

export const deleteArticle = async (slug, token) => {
  try {
    const response = await fetch(`/api/articles/${slug}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Ошибка при удалении статьи');
    }

    return await response.json();
  } catch (error) {
    console.error('Ошибка удаления статьи:', error);
    throw error;
  }
};

export const getArticleBySlug = async (slug) => {
  const response = await fetch(`/api/articles/${slug}`);
  if (!response.ok) {
    throw new Error('Ошибка получения статьи');
  }
  return await response.json();
};

export const updateArticle = async (slug, title, content, titleBel, contentBel, token) => {
  try {
    const response = await fetch(`/api/articles/${slug}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ title, content, titleBel, contentBel }),
    });

    if (!response.ok) {
      throw new Error('Ошибка при обновлении статьи');
    }

    return await response.json();
  } catch (error) {
    console.error('Ошибка обновления статьи:', error);
    throw error;
  }
};

export const uploadImage = async (file, token) => {
  const formData = new FormData();
  formData.append('image', file);

  try {
    const response = await fetch('/api/articles/upload', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Ошибка при загрузке изображения');
    }

    return await response.json();
  } catch (error) {
    console.error('Ошибка загрузки изображения:', error);
    throw error;
  }
};
